export const LOADING = "Loading";

export const getEarnTagText = (earnRate: string | number, currency: string) => {
  const multiplier = currency.includes("cash") ? "%" : "X";
  return `<span class="font-bold">Earn ${earnRate}${multiplier}</span> ${currency} on hotels`;
};

export const CANCEL_FOR_ANY_REASON = "Cancel for any reason";
